import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, ChevronDown } from 'lucide-react';
import StatusPicker from './StatusPicker';

// The usual next move is a button that names it; the rest is behind the chevron.
export default function StatusAdvance({ statuses, comeBackStatuses, nextStatus, value, onMove }) {
  const { t } = useTranslation('common');
  const [showAll, setShowAll] = useState(false);
  const next = nextStatus[value];

  const picker = (
    <StatusPicker statuses={statuses} comeBackStatuses={comeBackStatuses} value={value} onMove={onMove} />
  );
  if (!next) return picker;

  return (
    <div className="crm-advance">
      <button type="button" className="crm-btn primary crm-advance-btn" onClick={() => onMove({ status: next })}>
        <Check size={16} />
        {t(`crm.advance.${next}`)}
      </button>
      {showAll ? (
        picker
      ) : (
        <button
          type="button"
          className="crm-btn crm-advance-more"
          aria-label={t('crm.advance.otherStatus')}
          onClick={() => setShowAll(true)}
        >
          <ChevronDown size={16} />
        </button>
      )}
    </div>
  );
}
